import moment from 'moment';

export const formatNotificationDate = (x: Date) => {
  if (!x) return '';
  if (moment(x).isSame(moment(), 'day')) {
    return 'Today';
  }
  return moment(x).format('MMM Do, YYYY');
};
